import { ComparablePlanType } from '@coverright/data-access/types/medicare';

// ─── Cart item ────────────────────────────────────────────────────────────────

export interface CartItem {
  /** Plan type — determines cart slot */
  type: ComparablePlanType;
  // Identifiers (persisted to AppState)
  bidId: string;
  zip: string;
  county: string;
  planYear?: string;
  // Display fields (for the checkout modal cart tiles)
  planName: string;
  orgName: string;
  premium: number;
  deductible?: string;
  moop?: string;
  logoUrl?: string;
}

// ─── Cart ─────────────────────────────────────────────────────────────────────

export interface PlanCart {
  ma:  CartItem | null;
  mg:  CartItem | null;
  pdp: CartItem | null;
}

export const EMPTY_CART: PlanCart = { ma: null, mg: null, pdp: null };
